/**
 *
 * ActivityChip
 *
 * Renders the RAG activity status (green/amber/red) for a person, with
 * the numeric score shown on hover. See API ADR-0001.
 *
 */
import * as React from 'react';
import { Chip, Tooltip } from '@mui/material';

export type ActivityStatus = 'red' | 'amber' | 'green';

interface Props {
  status?: ActivityStatus | null;
  score?: number | null;
  size?: 'small' | 'medium';
}

const colorMap: Record<ActivityStatus, 'success' | 'warning' | 'error'> = {
  green: 'success',
  amber: 'warning',
  red: 'error',
};

const labelMap: Record<ActivityStatus, string> = {
  green: 'Active',
  amber: 'Quiet',
  red: 'Inactive',
};

export function ActivityChip(props: Props) {
  const { status, score, size = 'small' } = props;

  if (!status) {
    return null;
  }

  const chip = (
    <Chip size={size} color={colorMap[status]} label={labelMap[status]} />
  );

  if (score == null) {
    return chip;
  }

  return <Tooltip title={`Activity score: ${score}/100`}>{chip}</Tooltip>;
}
